import { __rest } from "tslib";
import * as React from 'react';
import { FocusTrap } from '../../helpers';
import modalStyles from '@patternfly/react-styles/css/components/ModalBox/modal-box';
import bullsEyeStyles from '@patternfly/react-styles/css/layouts/Bullseye/bullseye';
import { css } from '@patternfly/react-styles';
import { Backdrop } from '../Backdrop/Backdrop';
import { ModalBoxBody } from './ModalBoxBody';
import { ModalBoxCloseButton } from './ModalBoxCloseButton';
import { ModalBox } from './ModalBox';
import { ModalBoxFooter } from './ModalBoxFooter';
import { ModalBoxDescription } from './ModalBoxDescription';
import { ModalBoxHeader } from './ModalBoxHeader';
export var ModalContent = function ModalContent(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isOpen = _a.isOpen,
      isOpen = _a$isOpen === void 0 ? false : _a$isOpen,
      _a$header = _a.header,
      header = _a$header === void 0 ? null : _a$header,
      _a$description = _a.description,
      description = _a$description === void 0 ? null : _a$description,
      _a$title = _a.title,
      title = _a$title === void 0 ? '' : _a$title,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? '' : _a$ariaLabel,
      ariaDescribedby = _a['aria-describedby'],
      ariaLabelledby = _a['aria-labelledby'],
      _a$showClose = _a.showClose,
      showClose = _a$showClose === void 0 ? true : _a$showClose,
      _a$footer = _a.footer,
      footer = _a$footer === void 0 ? null : _a$footer,
      _a$actions = _a.actions,
      actions = _a$actions === void 0 ? [] : _a$actions,
      _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? function () {
    return undefined;
  } : _a$onClose,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'default' : _a$variant,
      _a$width = _a.width,
      width = _a$width === void 0 ? -1 : _a$width,
      boxId = _a.boxId,
      labelId = _a.labelId,
      descriptorId = _a.descriptorId,
      _a$disableFocusTrap = _a.disableFocusTrap,
      disableFocusTrap = _a$disableFocusTrap === void 0 ? false : _a$disableFocusTrap,
      _a$hasNoBodyWrapper = _a.hasNoBodyWrapper,
      hasNoBodyWrapper = _a$hasNoBodyWrapper === void 0 ? false : _a$hasNoBodyWrapper,
      props = __rest(_a, ["children", "className", "isOpen", "header", "description", "title", 'aria-label', 'aria-describedby', 'aria-labelledby', "showClose", "footer", "actions", "onClose", "variant", "width", "boxId", "labelId", "descriptorId", "disableFocusTrap", "hasNoBodyWrapper"]);

  if (!isOpen) {
    return null;
  }

  var modalBoxHeader = header ? React.createElement(ModalBoxHeader, null, header) : title && React.createElement(ModalBoxHeader, null, React.createElement("h1", {
    id: labelId,
    className: css(modalStyles.modalBoxTitle)
  }, title), description && React.createElement(ModalBoxDescription, {
    id: descriptorId
  }, description));
  var modalBoxFooter = footer ? React.createElement(ModalBoxFooter, null, footer) : actions.length > 0 && React.createElement(ModalBoxFooter, null, actions);
  var modalBody = hasNoBodyWrapper ? children : React.createElement(ModalBoxBody, Object.assign({}, props, !description && !ariaDescribedby && {
    id: descriptorId
  }), children);
  var boxStyle = width === -1 ? {} : {
    width: width
  };

  var ariaLabelledbyFormatted = function ariaLabelledbyFormatted() {
    if (ariaLabelledby === null) {
      return null;
    }

    var idRefList = [];

    if ((ariaLabel && boxId) !== '') {
      idRefList.push(ariaLabel && boxId);
    }

    if (ariaLabelledby) {
      idRefList.push(ariaLabelledby);
    }

    if (title) {
      idRefList.push(labelId);
    }

    return idRefList.join(' ');
  };

  var modalBox = React.createElement(ModalBox, {
    id: boxId,
    style: boxStyle,
    className: className,
    variant: variant,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledbyFormatted(),
    "aria-describedby": ariaDescribedby || (hasNoBodyWrapper ? null : descriptorId)
  }, showClose && React.createElement(ModalBoxCloseButton, {
    onClose: onClose
  }), modalBoxHeader, modalBody, modalBoxFooter);
  return React.createElement(Backdrop, null, React.createElement(FocusTrap, {
    active: !disableFocusTrap,
    focusTrapOptions: {
      clickOutsideDeactivates: true
    },
    className: css(bullsEyeStyles.bullseye)
  }, modalBox));
};